import React from "react";
import { Provider, connect } from "react-redux";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import "antd/dist/antd.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./common/styles/global.scss";
import { store } from "./common/services/ReduxService";
import AppEntry from "./AppEntry";

ReactDOM.render(
    <Provider store={store}>
        <AppEntry />
    </Provider>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
